import { Banner, Modal, BlockStack } from '@shopify/polaris'
import React from 'react'
import { DI, DIProps } from '../../../../Core';
interface Props extends DIProps {
    syncAction: (data: string, source_product_id: string) => void,
    syncModal: boolean,
    setsyncModal: (data: boolean) => void,
    actiontype: any
    syncmodalLoading: boolean
    totalProdCount: number
    t: any,
    FiftyPlus: boolean
    activePlan: string
}

function SyncModal(props: Props) {
    const { syncModal, t, syncAction, actiontype, syncmodalLoading, setsyncModal, totalProdCount, FiftyPlus, activePlan } = props;
    const doggyLips_user_id: string = "6154c2e343920520dd1867da";

    return (
        <Modal
            instant
            open={syncModal}
            onClose={() => setsyncModal(false)}
            title={t("Confirmation Required")}
            primaryAction={{
                content: actiontype.actionName,
                onAction: () => syncAction(actiontype.key, actiontype?.source_product_id),
                loading: syncmodalLoading,
                id: "upload_tour",
                disabled: (actiontype.title === 'Upload Product' || actiontype.title === 'Sync Product') && FiftyPlus && (activePlan == 'Free' || (totalProdCount > 10000 && props.redux.user_id !== '67ec62bff778398bd30d0292')) || (props.redux.user_id === doggyLips_user_id && FiftyPlus)
            }}
            secondaryActions={[{
                content: t('Cancel'),
                onAction: () => setsyncModal(false)
            }]}
        >
            <Modal.Section>
                {
                    (actiontype.title === 'Upload Product' || actiontype.title === 'Sync Product') && activePlan == 'Free' && FiftyPlus ?
                        <Banner tone='warning'>
                            {
                                `Dear user, please note that we are currently stopping bulk ${actiontype.title === 'Upload Product' ? " product upload " : ' product sync '} feature for our free plan users due to heavy traffic issue. If you are currently on our free plan, you will not be able to access this feature. Upgrade to our higher plan to enjoy this feature and other exclusive benefits. However, you can still ${actiontype.title === 'Upload Product' ? ' upload ' : ' sync '} 50 products at a time. Thank you for your understanding.`
                            }
                        </Banner>
                        :
                        (actiontype.title === 'Upload Product' || actiontype.title === 'Sync Product') && props.redux.user_id === doggyLips_user_id && FiftyPlus ?
                            <Banner tone='warning'>
                                {
                                    "To ensure a smooth selling experience during the festive season, we are limiting bulk upload to max 50 products."
                                }
                            </Banner>
                            :
                            (actiontype.title === 'Upload Product' || actiontype.title === 'Sync Product') && ((totalProdCount > 10000 && FiftyPlus) && props.redux.user_id !== '67ec62bff778398bd30d0292') ?
                                <Banner tone='warning'>
                                    <BlockStack gap="200">
                                        {
                                            `Dear users, we regret to inform you that we are temporarily unable to support ${actiontype.title === 'Upload Product' ? " upload " : ' syncing '} of 10k+ products on Amazon due to throttling issues. Our team is working to resolve this as soon as possible. Thank you for your understanding.`
                                        }
                                    </BlockStack>
                                </Banner>
                                :
                                <BlockStack gap="200">
                                    <p dangerouslySetInnerHTML={{ __html: actiontype.description }} />
                                </BlockStack>
                }
            </Modal.Section>
        </Modal>
    );
}

export default DI(SyncModal)